const RatePrice = ({ selectedRates, isQuted, quoteTemplate }) => {
    const isTemplate2 = (quoteTemplate ?? 'template-2') === 'template-2';
    const labels = isTemplate2
        ? ['Option 1', 'Option 2', 'HELOC']
        : ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5'];

    const colClass = isTemplate2 ? 'col-md-3' : 'col-md-2';

    return (
        <div className="">
            {/* Headers */}
            <div className="row g-3 mb-2">
                <div className={colClass}></div>
                {labels.map((label, i) => (
                    <div key={i} className={`${colClass} text-center`}>
                        <span className="font-weight-bold">{label}</span>
                    </div>
                ))}
            </div>

            {/* Rate row */}
            <div className="row g-3 mb-2">
                <div className={`${colClass} text-right`}>
                    <span className="font-weight-bold">Rate</span>
                </div>
                {selectedRates?.map((r, i) => (
                    <div key={i} className={colClass}>
                        <div className="border rounded py-1 px-2 bg-secondary text-center">
                            {r?.rate || 0.00} %
                        </div>
                    </div>
                ))}
                {isTemplate2 && (
                    <div className={colClass}>
                        <div className="border rounded py-1 px-2 bg-secondary text-center text-muted">
                            Auto
                        </div>
                    </div>
                )}
            </div>

            {/* Price row */}
            <div className="row g-3 mb-2">
                <div className={`${colClass} text-right`}>
                    <span className="font-weight-bold">Price</span>
                </div>
                {selectedRates?.map((r, i) => (
                    <div key={i} className={colClass}>
                        <div className="border rounded py-1 px-2 bg-secondary text-center">
                            {r?.price || 0.00} %
                        </div>
                    </div>
                ))}
                {isTemplate2 && (
                    <div className={colClass}>
                        <div className="border rounded py-1 px-2 bg-secondary text-center text-muted">
                            Auto
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default RatePrice
